export interface NutritionRow {
  name: string;
  amount: string;
  dri: string;
}

export interface ProductInfoData {
  ingredients: string;
  nutrition: NutritionRow[];
  hasNoDri?: boolean;
}

export const productInfo: Record<string, ProductInfoData> = {
  immunsupport: {
    ingredients:
      "Syra (citronsyra), surhetsreglerande medel (natriumbikarbonat), fyllnadsmedel (sorbitol, polyetylenglykol), svart fläderbärextrakt, färgande livsmedel (rödbetsjuicekoncentrat), Vitamin C (L-askorbinsyra), Zink (zinkcitrat), sötningsmedel (natriumcyklamat, natriumsackarin), aromer.",
    nutrition: [
      { name: "Vitamin C", amount: "60 mg", dri: "75%" },
      { name: "Zink", amount: "7,5 mg", dri: "75%" },
      { name: "Svart fläderbärextrakt", amount: "150 mg", dri: "**" },
    ],
    hasNoDri: true,
  },
  "c-vitamin": {
    ingredients:
      "Syra (citronsyra), Vitamin C (L-askorbinsyra), surhetsreglerande medel (natriumbikarbonat), fyllnadsmedel (sorbitol, polyetylenglykol), sötningsmedel (natriumcyklamat, natriumsackarin), arom, färgämne (betakaroten), färgande livsmedel (rödbetsjuicekoncentrat).",
    nutrition: [{ name: "Vitamin C", amount: "1000 mg", dri: "1250%" }],
  },
  "sol-gladje": {
    ingredients:
      "Syra (citronsyra), Vitamin C (L-askorbinsyra), surhetsreglerande medel (natriumbikarbonat), fyllnadsmedel (sorbitol, polyetylenglykol), Zink (zinkcitrat), sötningsmedel (natriumcyklamat, natriumsackarin), arom, Vitamin D3 (kolekalciferol), färgämne (riboflavin), färgande livsmedel (rödbetsjuicekoncentrat).",
    nutrition: [
      { name: "Vitamin C", amount: "1000 mg", dri: "1250%" },
      { name: "Zink", amount: "10 mg", dri: "100%" },
      { name: "Vitamin D", amount: "10 µg", dri: "200%" },
    ],
  },
  elektrolyter: {
    ingredients:
      "Surhetsreglerande medel (citronsyra), natriumvätekarbonat, fyllnadsmedel (sorbitol), kaliumcitrat, magnesiumcitrat, anti-klumpmedel (majsstärkelse), kalciumcitrat, Vitamin C (L-askorbinsyra), sötningsmedel (sukralos, acesulfam K), aromämnen, färgämne (riboflavin).",
    nutrition: [
      { name: "Vitamin C", amount: "40 mg", dri: "50%" },
      { name: "Vitamin B2 (riboflavin)", amount: "1 mg", dri: "71,4%" },
      { name: "Kalium", amount: "100 mg", dri: "5%" },
      { name: "Natrium", amount: "300 mg", dri: "**" },
      { name: "Magnesium", amount: "25 mg", dri: "6,7%" },
      { name: "Kalcium", amount: "15 mg", dri: "1,9%" },
    ],
    hasNoDri: true,
  },
  tropikollagen: {
    ingredients:
      "Surhetsreglerande medel (natriumbikarbonat), Syra (citronsyra), Fyllnadsmedel (sorbitol, polyetylenglykol), Marint kollagen (fisk), Vitamin C (L-askorbinsyra), Antiklumpmedel (majsstärkelse, kiseldioxid), Syra (äppelsyra), Natriumhyaluronat, Aromer, Vitamin B3 (nikotinamid), Sötningsmedel (sukralos, acesulfam K), Vitamin B2 (riboflavin), Biotin.",
    nutrition: [
      { name: "Vitamin C", amount: "160 mg", dri: "200%" },
      { name: "Vitamin B3", amount: "16 mg NE", dri: "100%" },
      { name: "Vitamin B2 (riboflavin)", amount: "1,6 mg", dri: "114%" },
      { name: "Biotin", amount: "1000 µg", dri: "2000%" },
      { name: "Marint kollagen", amount: "500 mg", dri: "**" },
      { name: "Hyaluronsyra", amount: "25 mg", dri: "**" },
    ],
    hasNoDri: true,
  },
};
